import * as React from "react"
import Image from 'next/image'

import { Card } from "@kit/ui/card"
import { GeneralContentSchemaType } from "~/lib/schemas/generalContentSchema.schema";
import { If } from "@kit/ui/if";
import { Link, Image as LucideImage } from "lucide-react";
import { formatCurrencyByCode } from "~/lib/currency-utils";
import { getFirstItemInArray } from "~/lib/utils";

interface ProductComponentProps {
  data: GeneralContentSchemaType;
  source: 'carousel' | 'catalog';
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export function ProductComponent(props: ProductComponentProps) {
  const imageSize = props.source === 'catalog' ? 300 : 184;

  const _handleCardClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    // If an external onClick is provided, use that instead of the default behavior
    if (props.onClick) {
      props.onClick(e);
      return;
    }
    
    if (props.data.action_urls.length > 0) {
      const firstUrl = props.data.action_urls[0];
      if (firstUrl && (firstUrl.startsWith('http://') || firstUrl.startsWith('https://'))) {
        window.open(firstUrl, '_blank');
      } else {
        console.error("[ProductComponent] Err: Invalid action URL");
      }
    } else {
      console.error("[ProductComponent] Err: No action URL available");
    }
  };

  return (
    <Card className="overflow-hidden cursor-pointer" key={props.data.id} style={{ maxWidth: `${imageSize}px` }} onClick={_handleCardClick}>
      <div className="flex flex-col h-full">
        <div className="bg-slate-500">
          {getFirstItemInArray(props.data.image_urls) && getFirstItemInArray(props.data.image_urls) !== "" ? (
            <Image
              src={getFirstItemInArray(props.data.image_urls) ?? ""}
              alt={props.data.title}
              width={imageSize}
              height={imageSize}
              className="w-full aspect-square"
            />
          ) : (
            <div 
              className="w-full aspect-square" 
              style={
                { 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  height: props.source === 'carousel' ? `${imageSize}px` : undefined
                }
              }>
              { props.data.content_type === "link" ? (
                <Link />
              ) : (
                <LucideImage />
              )}
            </div>
          )}
        </div>
        <div className="p-4">
          <div className="text-base font-semibold line-clamp-3 overflow-hidden">{props.data.title}</div>
          <If condition={props.data.price}>
            <div className="text-sm text-gray-500 overflow-hidden">{formatCurrencyByCode(props.data.price, props.data.currency)}</div>
          </If>
        </div>
      </div>
    </Card>
  );
}